import { render, staticRenderFns } from "./ribbons.vue?vue&type=template&id=357ca70b&"
import script from "./ribbons.vue?vue&type=script&lang=js&"
export * from "./ribbons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports